import type { KeyboardEvent } from "react";

const FOCUSABLE = "input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), button[data-field]:not([disabled])";

export function focusables(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter((el) => el.offsetParent !== null || el === document.activeElement);
}

// Tally-style entry: Enter moves to the next field and, from the last one, saves; Ctrl+S (⌘S) saves from anywhere.
// A field can keep Enter for itself by stopping the event (the combobox does while its list is open).
export function formKeys(e: KeyboardEvent<HTMLFormElement>) {
  const form = e.currentTarget;
  if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") { e.preventDefault(); form.requestSubmit(); return; }
  if (e.key !== "Enter" || e.shiftKey || e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return;
  const t = e.target as HTMLElement;
  if (t.tagName === "TEXTAREA" || t.tagName === "BUTTON") return;   // a button keeps Enter (it clicks)
  e.preventDefault();
  const all = focusables(form);
  const i = all.indexOf(t);
  const next = all[i + 1];
  if (next) { next.focus(); if (next instanceof HTMLInputElement && next.type !== "checkbox") next.select(); }
  else form.requestSubmit();
}
